import React from 'react';
import ReactPlayer from 'react-player';
import Modal from 'react-bootstrap/Modal';
import './styles.scss';

const VideoPlayer = ({
  open, url, toggleModal = () => {
  },
}) => (
  <Modal
    size='md'
    show={open}
    onHide={toggleModal}
    backdrop='static'
    keyboard={false}
    className='custom-modal'
  >
    <button
      onClick={toggleModal}
      type='button'
      className='close'
      data-dismiss='modal'
      aria-label='Close'
    >
      <span>
        <img
          src={require('../../../Assets/Images/Icons/close_icon_white.png')}
          alt=''
          style={{ width: 16, height: 'auto' }}
        />
      </span>
    </button>

    <ReactPlayer playing url={url} controls/>
  </Modal>
);

export default VideoPlayer;
